module.exports = __webpack_public_path__ + "static/thesis_capabilities_V2-0903737930abbf21a2a86acd7470d0d6.gif";